export default function quantity(resp) {
    return {
        label: resp.quantityLabel,
        max: resp.maxQuantity,
        errorMsg: null,
        selected: 1
    };
}
